
export default {
    name: 'ErrorOverlay',
    methods: {
        tryAgain() {
            location.reload();
        },
    },
    computed: {
        showError() {
            return this.$store.state.app.showServerError;
        },
    },
};
